import React from "react";

import { ReactComponent as AskFellowIcon } from "~/nav/icons/ask-fellow-outline.svg";
import { useAskFellowButton } from "~/nav/panels/AskFellow/AskFellowHooks";

import { ControlButton } from "./SharedComponents";

import type { AskFellowHooks_useAskFellowButton_note$key } from "~/__generated__/AskFellowHooks_useAskFellowButton_note.graphql";

import styles from "./FloatingAskFellowButton.module.css";

export default function FloatingAskFellowButton({
	note: noteKey,
	onStartConversation,
}: {
	note: AskFellowHooks_useAskFellowButton_note$key;
	onStartConversation?: () => void;
}) {
	const onCreateConversation = useAskFellowButton({ noteKey, source: "floating_note_button" });

	return (
		<ControlButton
			className={styles.askFellowButton}
			innerClassName={styles.askFellowButtonInner}
			onClick={onStartConversation ?? onCreateConversation}
		>
			<span className={styles.askFellowButtonText}>
				<AskFellowIcon className={styles.askFellowIcon} />
				Ask Fellow
			</span>
		</ControlButton>
	);
}
